import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * パンくず
 *【パンくずリスト:items:{title:string, name:string}[]】
 *【選択表示条件:showSelected:boolean】
 *【2ndデザイン:secondary:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.html',
  styles: [`
    
  `]
})
export class Breadcrumb extends BaseWidget {
  /**
   * パンくずリスト
   */
  @Input() items:{title:string, name:string}[]

  /**
   * 選択表示条件
   */
  @Input() showSelected:boolean

  /**
   * 2ndデザイン
   */
  @Input() secondary:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * デザイン状態を取得する
   *
   */
  get isSecondary() {
    if (!!this.secondary) {
      return true
    } else {
      return
    }
  }
}


// WEBPACK FOOTER //
// ./src/widgets/breadcrumb/breadcrumb/breadcrumb.component.ts